import React, { useEffect, useState } from 'react';
import Pagination from '@mui/material/Pagination';
import { Skeleton } from '@mui/material';
import { toast } from 'react-toastify';
import { setErrorMessage } from '../../../../../shared/helpers/functionalities';
import { PART_NOT_FOUND_API } from '../../../../../shared/services/partNotFound';
const SIZE_PAGE = 10;

const PartNotFoundHistory = () => {
    const [results, setResults] = useState({ items: [], total_items: 0 });
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);

    const getPaginationCount = () => {
        var totalPages =
            results?.total_items < SIZE_PAGE
                ? 1
                : Math.ceil(results?.total_items / SIZE_PAGE);
        return totalPages ? parseInt(totalPages) : 0;
    };

    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
        getHistoryRequest(newPage);
    };

    const getHistoryRequest = async (newPage) => {
        try {
            setIsLoading(true);
            const res = await PART_NOT_FOUND_API.get(newPage, SIZE_PAGE);
            if (res?.success) {
                return setResults(res.data);
            }
            toast.error('Error al obtener el histórico de piezas no encontradas')
        } catch (error) {
            toast.error(setErrorMessage(error));
        } finally {
            setIsLoading(false);
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        const date = new Date(dateStr);
        return date.toLocaleDateString('es-ES');
    };

    useEffect(() => {
        getHistoryRequest(1);
    }, []);

    return (
        <div className="w-100 mt-3" style={{ minHeight: '100vh' }}>
            {isLoading ? (
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Referencia</th>
                                <th>Teléfono</th>
                                <th>Usuario</th>
                                <th>Fecha creada</th>
                                <th>Fecha encontrada</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                                <tr key={i}>
                                    <td colSpan={5}><Skeleton variant="text" /></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : results.items.length === 0 ? (
                <p className="text-muted">No hay ninguna pieza no encontrada todavía.</p>
            ) : (
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="text-center">Referencia</th>
                                <th className="text-center">Teléfono</th>
                                <th className="text-center">Usuario</th>
                                <th className="text-center">Fecha creada</th>
                                <th className="text-center">Fecha encontrada</th>
                            </tr>
                        </thead>
                        <tbody>
                            {results.items.map((item) => (
                                <tr key={item.id}>
                                    <td className="text-center">{item.referencia}</td>
                                    <td className="text-center">{item.telefono}</td>
                                    <td className="text-center text-uppercase">{item.created_by?.username || '-'}</td>
                                    <td className="text-center">{formatDate(item.created_at)}</td>
                                    <td className="text-center">{item.encontrada ? formatDate(item.updated_at) : '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {results.total_items > SIZE_PAGE && (
                <Pagination
                    className="mt-3 d-flex justify-content-end"
                    count={getPaginationCount()}
                    page={currentPage}
                    onChange={handleChangePage}
                />
            )}
        </div>
    );
};

export default PartNotFoundHistory;